export default __webpack_public_path__ + "static/media/comic-translator.60e0167b.png";